/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2020 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import * as R from 'ramda';
import { createSelector } from 'reselect';
import { filterFromHash, filterToHash } from '@adobe/griffon-toolkit';
import { event, sessionAnnotation } from '@adobe/griffon-toolkit-common';
import { selectActiveSession } from '../../common/selectors';

const getClearTS = sessionAnnotation.search(
  sessionAnnotation.publicNamespace.visibility,
  sessionAnnotation.publicKey.clearSessionTS
);

const selectDefaults = createSelector(
  selectActiveSession,
  (session) => {
    const clearTS = getClearTS(session);
    return {
      hidden: event.makeHiddenFilter(clearTS)
    };
  }
);

const selectFilters = createSelector(
  R.path(['router', 'hash']),
  selectDefaults,
  (hash, defaults) => {
    const decoded = hash ? filterFromHash(hash) : false;
    return decoded || defaults;
  }
);

export default selectFilters;
export const selectFilterHash = createSelector(
  selectFilters,
  filterToHash
);
